import React, { Fragment, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { login } from "../../utils/API/LoginAPI";
import { useToken } from "../../utils/TokenContext";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import "./Login.css";
import SWLogoWhite from "../../assests/SW_logo_white.svg";
import loginImage from "../../assests/loginImage.png";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { FaUser } from 'react-icons/fa';

const SECRET_KEY = "your_secret_key"; // Replace with a strong secret key

const Login = () => {
  const { register, handleSubmit, setValue, formState: { errors } } = useForm();
  const { setToken } = useToken();
  const [processing, setProcessing] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const encryptedEmail = Cookies.get("email");
    const encryptedPassword = Cookies.get("password");
    if (encryptedEmail && encryptedPassword) {
      const decryptedEmail = CryptoJS.AES.decrypt(encryptedEmail, SECRET_KEY).toString(CryptoJS.enc.Utf8);
      const decryptedPassword = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY).toString(CryptoJS.enc.Utf8);
      setValue("email", decryptedEmail);
      setValue("password", decryptedPassword);
      setRememberMe(true);
    }
  }, [setValue]);

  const showToast = (message) => {
    toast.error(message);
  };

  const onSubmit = async (data) => {
    if (processing) return;
    try {
      setProcessing(true);
      const response = await login(data.email, data.password);
      
      if (response.statusValue === 200) {
        setToken(response.data);
        localStorage.setItem('name', response.userData.name);
        localStorage.setItem('nameIni', response.userData.nameInitials);
        localStorage.setItem('editAccess', response?.userData?.editAccess);

        // Handle Remember Me functionality
        if (rememberMe) {
          const encryptedEmail = CryptoJS.AES.encrypt(data.email, SECRET_KEY).toString();
          const encryptedPassword = CryptoJS.AES.encrypt(data.password, SECRET_KEY).toString();
          Cookies.set("email", encryptedEmail, { expires: 7 }); // Save for 7 days
          Cookies.set("password", encryptedPassword, { expires: 7 });
        } else {
          Cookies.remove("email");
          Cookies.remove("password");
        }

        navigate("/ticket-lists");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error:", error);
      showToast(`Error fetching login : ${error?.response?.data?.error?.message}`);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Fragment>
      <div className="SmartStoreLoginContainer">
        <div className="container-fluid">
          <div className="row g-0">
            <div className="col-md-6 SoreLogin_image d-flex align-items-center justify-content-center">
              <img src={loginImage} alt="loginImage" />
            </div>
            <div className="col-md-6 bg_LoginArea">
              <div className="SmartStoreLogin_Box d-flex align-items-center">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-8 mx-auto">
                      <div className="sw_Logo_Store">
                        <img src={SWLogoWhite} alt="SWLogoWhite" />
                      </div>
                      {loading ? "Loading..." : "Logged in successfully"}
                      {/* <div className="SmartStoreLogin px-4 py-4">
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <div className="form-group mb-3">
                            <label htmlFor="email">
                              Enter Email Address
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              {...register("email", { required: true })}
                              className="form-control"
                              id="email"
                            />
                            {errors.email && <span className="text-danger">Email is required</span>}
                          </div>
                          <div className="form-group mb-3 position-relative">
                            <div className="position-relative">
                              <label htmlFor="password">
                                Enter Password
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type={showPassword ? "text" : "password"} // Toggle input type based on state
                                {...register("password", { required: true })}
                                className="form-control"
                                id="password"
                              />
                              <span 
                              className="password-toggle-icon" 
                              onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                            >
                              {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                            </div>
                            
                            {errors.password && <span className="text-danger">Password is required</span>}
                          </div>

                          <div className="form-check mb-3">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="rememberMe"
                              checked={rememberMe}
                              onChange={() => setRememberMe(!rememberMe)}
                            />
                            <label className="form-check-label" htmlFor="rememberMe">
                              Remember Me
                            </label>
                          </div>

                          <div className="d-grid">
                            <button
                              type="submit"
                              className="btn btn-primary login_btn_SMartStore"
                              disabled={processing}
                            >
                              {processing ? "Processing..." : "Login"}
                            </button>
                          </div>
                        </form>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
